export const ID = 'b4ad383b-c492-43b6-89e2-973cfae0234c';

export const NAME = 'Blog Categories';
